import React from 'react'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.tz.setDefault('Asia/Tokyo')

type Props = {
  start: dayjs.Dayjs,
  end: dayjs.Dayjs,
}

const _isSameYear = (a: dayjs.Dayjs, b: dayjs.Dayjs): boolean => {
  return a.year() === b.year()
}

const _isSameMonth = (a: dayjs.Dayjs, b: dayjs.Dayjs): boolean => {
  return _isSameYear(a, b) && a.month() === b.month()
}

const _isSameDate = (a: dayjs.Dayjs, b: dayjs.Dayjs): boolean => {
  return _isSameMonth(a, b) && a.date() === b.date()
}

export default function StoryTerm(props: Props) {
  if (_isSameDate(props.start, props.end)) {
    return <time dateTime={props.start.format('YYYY-MM-DD')}>{props.start.format('MMM D, YYYY')}</time>
  }
  if (_isSameMonth(props.start, props.end)) {
    return (
      <>
        <time dateTime={props.start.format('YYYY-MM-DD')}>{props.start.format('MMM D')}</time> -{' '}
        <time dateTime={props.end.format('YYYY-MM-DD')}>{props.end.format('D, YYYY')}</time>
      </>
    )
  }
  if (_isSameYear(props.start, props.end)) {
    return (
      <>
        <time dateTime={props.start.format('YYYY-MM-DD')}>{props.start.format('MMM D')}</time> -{' '}
        <time dateTime={props.end.format('YYYY-MM-DD')}>{props.end.format('MMM D, YYYY')}</time>
      </>
    )
  }
  return (
    <>
      <time dateTime={props.start.format('YYYY-MM-DD')}>{props.start.format('MMM D, YYYY')}</time> -{' '}
      <time dateTime={props.end.format('YYYY-MM-DD')}>{props.end.format('MMM D, YYYY')}</time>
    </>
  )
}
